import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Datatable from 'vue2-datatable-component'
import vSelect from 'vue-select'
import VueAWN from 'vue-awesome-notifications'
import VueSweetalert2 from 'vue-sweetalert2'
import $ from 'jquery'

import axios from 'axios'
import VueAxios from 'vue-axios'

import App from './App.vue'
import router from './router/router'
import { store } from './store/store'

import BackButton from './components/partials/BackButton.vue'
import BSAlert from './components/partials/Alert.vue'
import EventHub from './components/partials/EventHub.vue'
import ButtonSpinner from './components/partials/VueButtonSpinner.vue'
import Loader from './components/partials/Loader.vue'
import HistoryLockButton from './components/HistoryLockButton.vue'

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import VueClipboard from 'vue-clipboard2'

window._ = require('lodash')
window.purify = o => JSON.parse(JSON.stringify(o))

window.constants = {
  pvsyst_2d_price: 125,
  pvsyst_3d_price: 250
}

window.Vue = Vue

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [new VueIntegration({logErrors: true})],
});

Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(Datatable)
Vue.use(VueAWN, {position: 'top-right'})
Vue.use(VueSweetalert2)

Vue.use(VueClipboard)

Vue.component('back-button', BackButton)
Vue.component('bootstrap-alert', BSAlert)
Vue.component('event-hub', EventHub)
Vue.component('vue-button-spinner', ButtonSpinner)
Vue.component('v-select', vSelect)
Vue.component('loader', Loader)
Vue.component('history-lock-button', HistoryLockButton)

// backend validation
Vue.directive('bValidate', {
  bind(el, binding, vnode) {

  },
  update(el, binding, vnode) {
    $(el).removeClass('has-danger show-feedback')
    $(el).find('.form-control-feedback').remove()

    if (binding.value.errors) {
      for (let name in binding.value.errors) {
        let errors = binding.value.errors[name]
        if (binding.value.name === name) {
          $(el).addClass('has-danger show-feedback')

          for (let key in errors) {
            $(el).append('<div class="form-control-feedback">' + errors[key] + '</div>')
          }
        }
      }
    }
  }
})

axios.defaults.baseURL = process.env.BASE_API_URL
axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
    return config
  },
  error => Promise.reject(error)
)

axios.interceptors.response.use(
  response => response,
  error => {
    app.$emit('error', error)
    return Promise.reject(error)
  })

const app = new Vue({
  el: '#app',
  data: {
    relationships: {}
  },
  watch: {
    '$route': function(value) {
      this.$emit('sm-menu-close')
    }
  },
  methods: {
    secondsToTimestring(seconds) {

      seconds = Math.abs(seconds) / 3600

      let hours = Math.floor(seconds);
      let minutesRaw = seconds - hours;
      let minutes = Math.round(60 * minutesRaw);
      if (minutes === 60) {
        hours++;
        minutes = 0;
      }

      return this.leadingZero(hours) + ':' + this.leadingZero(minutes);
    },
    leadingZero(number) {
      return number > 9 ? '' + number : '0' + number;
    },
  },
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js